export default "__VITE_ASSET__108e8dd7__"